import Framework, { LoadingHandler, shapes } from '@greenville/framework';
import { Box, Grid, ListItem, ListItemText, Paper, TextField, Typography, makeStyles } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import PreviewIcon from '@mui/icons-material/Preview';
import { Autocomplete } from '@mui/material';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import axios from 'axios';
import _ from 'lodash';
import { toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';
import Loader from '../../../../common/Loader';
import DialogBox from '../../../../common/components/DialogBox';
import TableComponent from '../../../../common/components/Table';
import TooltipCustom from '../../../../common/components/TooltipCustom';
import ColumnConfig from '../../../../common/config/ColumnConfig';
import * as constants from '../../../../common/constants';
import env from '../../../../common/env';
import utils from '../../../../common/utils';
import UsersPermissions from '../../../users/models/UsersPermissions';
import chatGptAdminPromptsData from '../../models/ChatGptAdminPrompts';
import PromptTypes from '../../models/PromptTypes';
// import PromptFeatureModel from '../../models/PromptFeature';
import TenantConfigModel from '../../models/TenantConfig';
import UserPermissionCheck from '../../models/UserPermissionCheck';
import AdminPromptDialog from './AdminPromptDialog';
// import AdminPromptEvaluateDialog from './AdminPromptEvaluateDialog';
import HistoryDialog from './HistoryDialog';

const useStyles = makeStyles({
  button: {
    backgroundColor: '#005d83 !important',
    color: 'white !important'
  }
});

const AdminPromptComponent = (props) => {
  const classes = useStyles();
  const {
    chatgptAdminPrompts,
    ChatGptGetAdminPromptsStatus,
    ChatGptUtilityAddAdminStatus,
    ChatGptEditAdminPromptsStatus,
    userPermissions,
    language,
    tenantConfig,
    userPermissionCheck,
    promptGetTypes
  } = props;
  const history = useHistory();
  const [archived, setArchived] = useState(false);
  const [showCloneIcon, setShowCloneIcon] = useState(false);
  const [isDialogboxOpen, setIsDialogboxOpen] = useState(false);
  const [rowItem, setRowItem] = useState('');
  const [itemName, setItemName] = useState('');
  const [archiveDialogContent, setArchiveDialogContent] = useState(null);
  const [promptsData, setPromptsData] = useState([]);
  const [archieveData, setArchievedData] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  // const [openEvaluateDialog, setOpenEvaluateDialog] = useState(false);
  const [order, setOrder] = useState('ASC');
  const [directionValue, setDirectionValue] = useState('');
  const [selectedValue, setSelectedValue] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [tenantKey, setTenantKey] = useState('');
  const [userToken, setUserToken] = useState('');
  const [apiLoading, setApiLoading] = useState(false);
  const permissionsList = toJS(userPermissions.permissionList.permissions);
  const [promptStatusValue, setpromptStatusValue] = useState('Live');
  const [promptTypeValue, setpromptTypeValue] = useState('');
  const [historyData, setHistoryData] = useState([]);
  const [historyDialog, setHistoryDialog] = useState(false);
  const promptStatusList = [
    { id: 'Live', value: 'Live' },
    { id: 'Archived', value: 'Archived' },
    { id: 'Draft', value: 'Draft' },
    { id: 'Experiment', value: 'Experiment' }
  ];
  const [types, setTypes] = useState([]);
  const [promptResponseData, setPromptResponseData] = useState([]);
  const [tenantIdValue, setTenantIdValue] = useState('');

  const getPromptsData = async (tenantIdVal) => {
    try {
      setApiLoading(true);
      const headers = {
        Authorization: `Bearer ${userToken}`
      };
      const response = await axios.post(
        `${env.EVERGREEN_API_BASE_URL}${constants.GET_ADMIN_PROMPTS_URL}`,
        { tenantId: tenantIdVal },
        { headers }
      );
      if (response && response.data && response.data.data) {
        const responseData = response.data.data;
        const archieve = response.data.data.filter((item) => item.status === 'ARCHIVED');
        const unArchieve = response.data.data.filter((item) => item.status === 'LIVE');
        setPromptResponseData(responseData);
        setArchievedData(archieve);
        setPromptsData(unArchieve);
        setArchived(true);
        setShowCloneIcon(true);
      }
    } finally {
      setApiLoading(false);
      setTenantIdValue(tenantIdVal);
    }
  };

  const getTenantId = (keyName) => {
    let tenTId = '';
    const { data } = toJS(tenantConfig);
    if (data.length > 0) {
      const match = data.find((config) => config.name === keyName);
      if (match) {
        tenTId = match.tenantId;
      }
    }

    return tenTId;
  };

  const fetchTypes = () => {
    const payload = {};
    payload.tenantId = tenantIdValue;
    promptGetTypes.fetchPromptTypes(payload);
    Framework.getEventManager().on(constants.SET_PROMPT_TYPES_DATA, () => {
      const { data } = promptGetTypes;
      const typesTemp = toJS(data);
      const uniqueTypes = [...new Set(typesTemp)];
      if (uniqueTypes && uniqueTypes.length > 0) {
        setTypes(uniqueTypes);
      }
    });
  };

  useEffect(() => {
    const token = utils.getToken();
    setUserToken((prev) => (prev !== token ? token : prev));
  }, []);

  useEffect(() => {
    if (!_.isEmpty(userToken)) {
      const locationVal = history.location.pathname.split('/')[2];
      setTenantKey(locationVal);
      const tenantIdVal = getTenantId(locationVal);
      if (tenantIdVal !== tenantIdValue) {
        getPromptsData(tenantIdVal);
      }
    }
  }, [userToken]);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    const eventManager = Framework.getEventManager();
    const handler = () => {
      if (!_.isEmpty(tenantIdValue)) {
        getPromptsData(tenantIdValue);
        fetchTypes();
      }
    };
    if (!_.isEmpty(tenantIdValue)) {
      fetchTypes();
      eventManager.on(constants.SET_ADMIN_PROMPTS_UPDATED_DATA, handler);
    }
  }, [tenantIdValue]);

  const sorting = (value, archivedStatus) => {
    const sortData = archivedStatus ? archieveData : promptsData;
    const promptArrow = ['promptStart', 'promptEnd'].includes(value);
    const dateFieldMatch = ['createdDate', 'updatedDate'].includes(value);
    if (order === 'ASC' && !promptArrow) {
      let sorted;
      if (dateFieldMatch) {
        sorted = [...sortData].sort((a, b) => a[value] && b[value] && new Date(a[value]) - new Date(b[value]));
      } else {
        sorted = [...sortData].sort((a, b) =>
          a[value] && b[value] && a[value].toLowerCase() > b[value].toLowerCase() ? 1 : -1
        );
      }
      if (archivedStatus) {
        setArchievedData(sorted);
      } else {
        setPromptsData(sorted);
      }
      setOrder('DSC');
      setDirectionValue(value);
    }
    if (order === 'DSC' && !promptArrow) {
      let sorted;
      if (dateFieldMatch) {
        sorted = [...sortData].sort((a, b) => a[value] && b[value] && new Date(b[value]) - new Date(a[value]));
      } else {
        sorted = [...sortData].sort((a, b) =>
          a[value] && b[value] && a[value].toLowerCase() < b[value].toLowerCase() ? 1 : -1
        );
      }
      if (archivedStatus) {
        setArchievedData(sorted);
      } else {
        setPromptsData(sorted);
      }
      setOrder('ASC');
      setDirectionValue(value);
    }
  };

  const onColumnClick = (val, archivedStatus) => {
    sorting(val, archivedStatus);
  };

  const changeToRawText = (promptVal) => {
    const { promptStart, promptEnd } = promptVal;
    const promptStartRawText = promptStart?.map((item) => {
      return { ...item, content: item.content };
    });
    const promptEndRawText = promptEnd?.map((item) => {
      return { ...item, content: item.content };
    });
    return { ...promptVal, promptStart: promptStartRawText, promptEnd: promptEndRawText };
  };

  const onRowClick = (val) => {
    setIsEdit(true);
    setOpenDialog(true);
    setSelectedValue(changeToRawText(val));
  };

  const handleClose = () => setOpenDialog(false);

  const handleAddNewPrompts = () => {
    setOpenDialog(true);
    setSelectedValue({});
    setIsEdit(false);
  };

  const handleTextFieldHandler = (e) => {
    e.preventDefault();
    setItemName(e.target.value);
  };

  const handleArchivedclick = (event, item) => {
    setArchiveDialogContent('');
    setRowItem(item);
    setIsDialogboxOpen(true);
    event.stopPropagation();
  };

  const handleArchivedClose = () => {
    setIsDialogboxOpen(false);
    setItemName('');
  };

  const fetchPromptProperties = async (payload, versionValue) => {
    try {
      setApiLoading(true);
      const headers = {
        Authorization: `Bearer ${userToken}`
      };
      const response = await axios.post(
        `${env.EVERGREEN_API_BASE_URL}${constants.GET_PROMPT_PROPERTIES_URL}`,
        { tenantId: tenantIdValue, promptVersion: versionValue, promptType: payload.type },
        { headers }
      );
      let propertiesDetails = {};
      if (response && response.data && response.data.data) {
        setApiLoading(false);
        propertiesDetails = response.data?.data?.promptModelsMapping?.[0];
      }
      return propertiesDetails;
    } finally {
      setApiLoading(false);
    }
  };

  const getNextVersion = (versionValue) => {
    const regex = /^(\d+)\.(\d+)\.(\d+)$/;
    const match = regex.exec(versionValue);
    const majorVersion = parseFloat(match[1]);
    const minorVersion = parseFloat(match[2]);
    const patchVersion = parseFloat(match[3]);
    return `${majorVersion}.${minorVersion}.${patchVersion + 1}`;
  };

  const handleClone = async (event, item) => {
    event.preventDefault();
    event.stopPropagation();
    if (item.version) {
      const versionData = [...promptsData, ...archieveData]
        .filter((val) => val.type === item.type)
        .map((d) => ({
          version: d.version
        }));
      const sortedVersionData = versionData.sort((a, b) => {
        const lowNumArr = a.version.split('.').map(Number);
        const highNumArr = b.version.split('.').map(Number);
        /* eslint-disable-next-line */
        for (let i = 0; i < lowNumArr.length; i++) {
          if (lowNumArr[i] !== highNumArr[i]) {
            return highNumArr[i] - lowNumArr[i];
          }
        }
        return 0;
      });

      const payload = {
        type: item.type && item.type.toUpperCase(),
        status: constants.PROMPT_DRAFT_STATUS,
        version: getNextVersion(sortedVersionData[0].version),
        tenantId: getTenantId(tenantKey),
        tenantName: item?.tenantName,
        promptStart: item.promptStart,
        promptEnd: item.promptEnd
      };

      const propertiesData = await fetchPromptProperties(payload, item.version);
      const finalValues = !_.isEmpty(propertiesData)
        ? {
            ...payload,
            promptProperties: {
              promptModelsMapping: {
                ...propertiesData,
                promptVersion: payload.version
              },
              bookId: 'default',
              feature: payload.type
            }
          }
        : payload;
      await chatgptAdminPrompts.saveAdminPromptsData(finalValues);
    }
    handleClose();
  };

  const handleConfirmAction = async (confirmed) => {
    if (confirmed && itemName) {
      handleArchivedClose();
      const payload = {
        ...rowItem,
        type: rowItem.type && rowItem.type.toUpperCase(),
        status: 'LIVE',
        comments: itemName
      };
      const propertiesData = await fetchPromptProperties(payload, payload.version);
      try {
        setApiLoading(true);
        const finalValues = _.isEmpty(propertiesData)
          ? payload
          : {
              ...payload,
              promptProperties: {
                promptModelsMapping: propertiesData,
                bookId: 'default',
                feature: payload.type
              }
            };
        await chatgptAdminPrompts.updateAdminPromptsData(finalValues);
      } finally {
        setApiLoading(false);
      }
    }
  };

  const getFilteredPromptData = (type, status) => {
    let archieve = promptResponseData.filter((item) => item.status === status);
    let unArchieve = promptResponseData.filter((item) => item.status === status);
    if (type !== '') {
      archieve = promptResponseData.filter((item) => item.status === 'ARCHIVED' && item.type === type);
      unArchieve = promptResponseData.filter((item) => item.status === status && item.type === type);
    }
    setArchievedData(archieve);
    setPromptsData(unArchieve);
  };

  const handlePromptStatusChange = (event) => {
    const promptTypeSelected = promptTypeValue.toUpperCase();
    const promptStatusSelected = event.target.value.toUpperCase();
    setpromptStatusValue(event.target.value);
    getFilteredPromptData(promptTypeSelected, promptStatusSelected);
  };

  const handleInputChange = (event) => {
    const promptTypeSelected = event.target.value.toUpperCase();
    const promptStatusSelected = promptStatusValue.toUpperCase();
    setpromptTypeValue(event.target.value);
    getFilteredPromptData(promptTypeSelected, promptStatusSelected);
  };

  // const handleEvaluate = (event, item) => {
  //   setOpenEvaluateDialog(true);
  //   setSelectedValue(item);
  //   event.stopPropagation();
  // };

  // const handleEvaluateClose = () => {
  //   setOpenEvaluateDialog(false);
  //   setSelectedValue({});
  // };

  const handleReset = () => {
    setpromptStatusValue('Live');
    setpromptTypeValue('');
    getFilteredPromptData('', constants.PROMPT_LIVE_STATUS);
  };

  const handleLLMEvaluationClick = () => {
    const selectedTenantName = history.location.pathname.split('/');
    // eslint-disable-next-line prefer-destructuring
    const tenantName = selectedTenantName[2];
    history.push(`/chatgptutility/${tenantName}/promptmgt/effectiveness`);
  };

  const handleViewHistory = async (rowData) => {
    setApiLoading(true);
    const tokenValue = utils.getToken();
    const headers = {
      'x-berlin-tenant-id': rowData?.tenantId,
      'x-berlin-tenant-key': '',
      Authorization: `Bearer ${tokenValue}`
    };
    const response = await axios.get(
      `${env.EVERGREEN_API_BASE_URL_V2}${constants.PROMPT_HISTORY_URL}?type=${rowData?.type}`,
      {
        headers
      }
    );

    if (response && response.data && response.data.data && response.data.data.length > 0) {
      const responseData = response.data.data;
      setHistoryData(responseData);
      setHistoryDialog(true);
    } else {
      const notification = {
        open: true,
        message: constants.PROMPT_HISTORY_ERROR_MSG,
        type: 'info'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
    }
    setApiLoading(false);
  };

  const handleCloseNew = () => {
    setHistoryData([]);
    setHistoryDialog(false);
  };
  return (
    <>
      <LoadingHandler
        loading={
          apiLoading ||
          ChatGptGetAdminPromptsStatus.isPending ||
          ChatGptUtilityAddAdminStatus.isPending ||
          ChatGptEditAdminPromptsStatus.isPending
        }
        loadingContent={<Loader />}
        content={
          <Paper style={{ padding: '10px' }}>
            <Grid container spacing={2} style={{ flexDirection: 'column' }}>
              <Box display="flex" style={{ justifyContent: 'flex-end', marginTop: '20px', marginRight: '30px' }}>
                <TooltipCustom
                  title={
                    !userPermissionCheck?.isPermissionCheck && !permissionsList.includes('admin_can_edit') ? (
                      <FormattedMessage {...language.getText('user.PERMISSIONS_LABEL')} />
                    ) : (
                      <FormattedMessage {...language.getText('admin.ADD_NEW_PROMPT')} />
                    )
                  }
                >
                  <span>
                    <Button
                      variant="contained"
                      color="primary"
                      startIcon={<AddIcon />}
                      onClick={handleAddNewPrompts}
                      disabled={!userPermissionCheck?.isPermissionCheck || !permissionsList.includes('admin_can_edit')}
                      className={
                        userPermissionCheck?.isPermissionCheck && permissionsList.includes('admin_can_view')
                          ? classes.button
                          : ''
                      }
                      style={{ marginRight: '8px' }}
                    >
                      Add New Prompt
                    </Button>
                  </span>
                </TooltipCustom>
                {![
                  '/chatgptutility/channels/promptmgt',
                  // '/chatgptutility/pvs/promptmgt',
                  '/chatgptutility/paceblueprint/promptmgt'
                  // '/chatgptutility/rplus/promptmgt',
                  // '/chatgptutility/activehub/promptmgt'
                ].includes(history.location.pathname) && (
                  <TooltipCustom
                    title={
                      !userPermissionCheck?.isPermissionCheck && !permissionsList.includes('admin_can_edit') ? (
                        <FormattedMessage {...language.getText('user.PERMISSIONS_LABEL')} />
                      ) : (
                        <FormattedMessage {...language.getText('effectiveness.LLM_EVALUATION')} />
                      )
                    }
                  >
                    <span>
                      <Button
                        variant="contained"
                        color="primary"
                        startIcon={<PreviewIcon />}
                        onClick={handleLLMEvaluationClick}
                        disabled={
                          !userPermissionCheck?.isPermissionCheck || !permissionsList.includes('admin_can_view')
                        }
                        className={
                          userPermissionCheck?.isPermissionCheck && permissionsList.includes('admin_can_view')
                            ? classes.button
                            : ''
                        }
                      >
                        LLM Evaluation
                      </Button>
                    </span>
                  </TooltipCustom>
                )}
              </Box>
            </Grid>
            <Grid container spacing={2} style={{ flexDirection: 'column' }}>
              <Box display="flex" style={{ marginLeft: '30px' }}>
                <Typography variant="h5" spacing={9} style={{ marginTop: '4px' }}>
                  Filter By
                </Typography>
                <FormControl sx={{ mt: 1 }} size="small" required>
                  <Autocomplete
                    disablePortal
                    id="promptStatus"
                    options={promptStatusList}
                    getOptionLabel={(option) => option.value || ''}
                    value={promptStatusList.find((opt) => opt.id === promptStatusValue) || null}
                    onChange={(event, newValue) =>
                      handlePromptStatusChange({ target: { name: 'promptStatus', value: newValue?.id || '' } })
                    }
                    sx={{ width: 200, marginRight: '20px', marginLeft: '20px' }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={constants.SELECT_PLACEHOLDER_STATUS}
                        name="promptStatus"
                        variant="outlined"
                        size="small"
                        InputProps={{
                          ...params.InputProps,
                          style: {
                            height: 41,
                            padding: 0
                          },
                          inputProps: {
                            ...params.inputProps,
                            style: {
                              padding: '6px 8px'
                            }
                          }
                        }}
                        InputLabelProps={{
                          style: {
                            fontSize: '0.9rem',
                            top: '-7px'
                          }
                        }}
                      />
                    )}
                  />
                </FormControl>

                <FormControl sx={{ mt: 1, width: '28%' }} size="small" required>
                  {types.length > 0 ? (
                    <Autocomplete
                      id="types"
                      options={[...types].sort((a, b) => a.localeCompare(b))}
                      value={promptTypeValue || null}
                      onChange={(event, newValue) => {
                        setpromptTypeValue(newValue || '');
                        handleInputChange({ target: { name: 'promptType', value: newValue || '' } });
                      }}
                      renderOption={(prop, option) => (
                        <ListItem {...prop} component="div">
                          <ListItemText primary={<Typography variant="body">{option}</Typography>} />
                        </ListItem>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={constants.SELECT_PLACEHOLDER_TYPE}
                          variant="outlined"
                          size="small"
                          fullWidth
                          InputProps={{
                            ...params.InputProps,
                            style: {
                              height: 41,
                              padding: 0
                            },
                            inputProps: {
                              ...params.inputProps,
                              style: {
                                padding: '6px 8px'
                              }
                            }
                          }}
                          InputLabelProps={{
                            style: {
                              fontSize: '0.9rem',
                              top: '-7px'
                            }
                          }}
                        />
                      )}
                    />
                  ) : (
                    <TextField
                      disabled
                      size="small"
                      label="Fetching Types..."
                      variant="outlined"
                      fullWidth
                      InputProps={{
                        style: {
                          height: 41,
                          padding: 0
                        },
                        inputProps: {
                          style: {
                            padding: '6px 8px'
                          }
                        }
                      }}
                      InputLabelProps={{
                        style: {
                          fontSize: '0.9rem',
                          top: '-7px'
                        }
                      }}
                    />
                  )}
                </FormControl>
                <FormControl sx={{ mt: 1, ml: 2 }} size="small" required>
                  <Button variant="contained" size="small" sx={{ background: '#005d83' }} onClick={() => handleReset()}>
                    RESET
                  </Button>
                </FormControl>
              </Box>
            </Grid>
            <Box sx={{ width: '100%' }} style={{ marginTop: '30px' }}>
              {promptStatusValue === 'Archived' ? (
                <TableComponent
                  columns={ColumnConfig.AdminPromptsDataGridColumn}
                  data={archieveData}
                  onColumnClick={onColumnClick}
                  order={order}
                  onRowClick={onRowClick}
                  directionValue={directionValue}
                  userEmailDetails=""
                  onMouseEnter={() => {}}
                  archived={archived}
                  handleArchivedclick={handleArchivedclick}
                  disableRepublish={
                    !userPermissionCheck?.isPermissionCheck || !permissionsList.includes('admin_can_edit')
                  }
                  showHistory
                  handleViewHistory={handleViewHistory}
                  isPermissionCheck={userPermissionCheck?.isPermissionCheck}
                />
              ) : (
                <TableComponent
                  columns={ColumnConfig.AdminPromptsDataGridColumn}
                  data={promptsData}
                  onColumnClick={onColumnClick}
                  order={order}
                  onRowClick={onRowClick}
                  directionValue={directionValue}
                  userEmailDetails=""
                  onMouseEnter={() => {}}
                  showCloneIcon={showCloneIcon}
                  handleClone={handleClone}
                  disableRepublish={
                    !userPermissionCheck?.isPermissionCheck || !permissionsList.includes('admin_can_edit')
                  }
                  status={promptStatusValue}
                  // handleEvaluate={handleEvaluate}
                  showHistory
                  handleViewHistory={handleViewHistory}
                  isPermissionCheck={userPermissionCheck?.isPermissionCheck}
                />
              )}
            </Box>
          </Paper>
        }
      />
      {openDialog && (
        <AdminPromptDialog
          openDialog={openDialog}
          handleClose={handleClose}
          selectedValue={selectedValue}
          promptTypes={types}
          isEdit={isEdit}
          tenantKey={tenantKey}
          permissionsList={permissionsList}
          language={language}
          tenantIdValue={tenantIdValue}
          isPermissionCheck={userPermissionCheck?.isPermissionCheck}
        />
      )}
      {isDialogboxOpen && (
        <DialogBox
          open={isDialogboxOpen}
          handleClose={handleArchivedClose}
          title={constants.ADMIN_PROMPT_RESTORE_DIALOG_TEXT}
          content={archiveDialogContent}
          handleConfirm={handleConfirmAction}
          handleTextFieldHandler={handleTextFieldHandler}
          itemName={itemName}
        />
      )}
      {/* {openEvaluateDialog && (
        <AdminPromptEvaluateDialog
          openDialog={openEvaluateDialog}
          handleClose={handleEvaluateClose}
          selectedValue={selectedValue}
        />
      )} */}

      {historyDialog && (
        <HistoryDialog
          openhistory={historyDialog}
          close={handleCloseNew}
          rowData={historyData}
          // workflowHistory={workflow.workflowHistoryData}
          // workflowHistoryStatus={workflowHistoryStatus}
        />
      )}
    </>
  );
};

AdminPromptComponent.propTypes = {
  chatgptAdminPrompts: shapes.modelOf(chatGptAdminPromptsData).isRequired,
  ChatGptGetAdminPromptsStatus: shapes.state.isRequired,
  ChatGptUtilityAddAdminStatus: shapes.state.isRequired,
  ChatGptEditAdminPromptsStatus: shapes.state.isRequired,
  userPermissions: shapes.modelOf(UsersPermissions).isRequired,
  tenantConfig: shapes.modelOf(TenantConfigModel).isRequired,
  language: shapes.language.isRequired,
  userPermissionCheck: shapes.modelOf(UserPermissionCheck).isRequired,
  promptGetTypes: shapes.modelOf(PromptTypes).isRequired
};

export default observer(
  inject(
    'chatgptAdminPrompts',
    'ChatGptGetAdminPromptsStatus',
    'ChatGptUtilityAddAdminStatus',
    'ChatGptEditAdminPromptsStatus',
    'userPermissions',
    'language',
    'tenantConfig',
    'userPermissionCheck',
    'promptGetTypes'
  )(AdminPromptComponent)
);
